<template>
  <listado-noticias
    endpoint="/noticias/todasNoticiasVisibles"
    title="Noticias"
    eyebrow="Actualidad"
    subtitle="Toda la actualidad de la parroquia."
  />
</template>

<script>
import listadoNoticias from "@/components/website/ListadoNoticias.vue";

export default {
  name: "vistaNoticias",
  components: {
    listadoNoticias,
  },
  metaInfo() {
    return {
      title: `${this.$root.constantes.nombre_sitio} - Noticias`,
      meta: [
        {
          name: "description",
          content: `Noticias sobre la ${this.$root.constantes.nombre_sitio}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: `${this.$root.constantes.sitio_web}${this.$route.fullPath}`,
        },
      ],
    };
  },
};
</script>
